import { logError } from 'libs/utils/window';
const LOG_SCOPE = 'PushUp';

function logErrorInScope(value) {
  if (!(value instanceof Error)) return; // eslint-disable-next-line no-param-reassign

  value.message = "".concat(LOG_SCOPE, ": ").concat(value.message);
  logError(value);
}

export default logErrorInScope;